/**
 * §13.1 prohibited patterns, as data for tests and the copy lint. This file intentionally contains examples
 * of copy the platform must never ship; its name carries `forbidden` so `pnpm lint:copy` skips it.
 */
/** The named prohibited patterns from §13.1 (and §4.2 F / §2.4 loss-experience baseline). */
export const PROHIBITED_PATTERN_NAMES = [
    'pre-ticked consent',
    'disguised advertising',
    'confirm-shaming',
    'fake scarcity',
    'misleading near-miss',
    'autoplay sound',
    'forced sharing',
    'hidden paid entry',
    'obstruction of exit',
    're-entry copy implying a due win',
    'wheel timing suggests influence',
    'resetting countdown',
    'invented participants or social proof',
];
/** Phrase-level detectors (mirrors tools/lint/forbidden-copy.mjs so contracts tests and the repo lint agree). */
export const PROHIBITED_COPY_PATTERNS = [
    { pattern: /so close!?/i, name: 'misleading near-miss' },
    { pattern: /almost won/i, name: 'misleading near-miss' },
    { pattern: /nearly won/i, name: 'misleading near-miss' },
    { pattern: /you'?re due/i, name: 're-entry copy implying a due win' },
    { pattern: /due for a win/i, name: 're-entry copy implying a due win' },
    { pattern: /your turn (is )?next/i, name: 're-entry copy implying a due win' },
    { pattern: /only \d+ left!? hurry/i, name: 'fake scarcity' },
    { pattern: /last chance!?/i, name: 'fake scarcity' },
    { pattern: /don'?t miss out/i, name: 'fake scarcity' },
    { pattern: /someone just won/i, name: 'invented participants or social proof' },
    { pattern: /increase(s|d)? your (odds|chances)/i, name: 're-entry copy implying a due win' },
    { pattern: /better luck next time/i, name: 'misleading near-miss' },
    { pattern: /try again next time/i, name: 'misleading near-miss' },
    { pattern: /no thanks,? i (don'?t|do not) (want|like)/i, name: 'confirm-shaming' },
    { pattern: /spin (now|again) to (win|change)/i, name: 'wheel timing suggests influence' },
    { pattern: /time your (spin|tap)/i, name: 'wheel timing suggests influence' },
];
/** Examples a test uses to prove the detectors fire. Never import this into runtime code. */
export const PROHIBITED_COPY_EXAMPLES = [
    'So close! Spin again to win.',
    "You're due for a win — enter again now!",
    'Only 3 left! Hurry!',
    'Last chance! Don’t miss out.',
    'Someone just won a car!',
    'Better luck next time.',
    'Entering again increases your odds.',
];
/** Returns the first prohibited pattern a string trips, or `null` when the copy is clean. */
export const findProhibitedCopy = (text) => {
    for (const { pattern, name } of PROHIBITED_COPY_PATTERNS) {
        const m = pattern.exec(text);
        if (m)
            return { match: m[0], name };
    }
    return null;
};
//# sourceMappingURL=copy-forbidden.js.map